<template>
  <MasterdataTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :table-data="tableData"
    :pagination="false"
    @row-click="onRowClick"
  >
    <v-menu
      slot="left"
      v-model="dateDialoag"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          rounded
          filled
          v-model="dateRangeText"
          dense
          :hide-details="true"
          v-on="on"
          v-bind="attrs"
          readonly
          prepend-inner-icon="mdi-calendar-range"
          class="mr-4"
        ></v-text-field>
      </template>
      <v-date-picker
        first-day-of-week="1"
        v-model="dates"
        range
      ></v-date-picker>
    </v-menu>
    <template v-slot:modal>
      <v-dialog :value="Boolean(selectedTrainDeviation)" width="700" persistent>
        <LinkDeviationTrainDeviationModal
          v-if="Boolean(selectedTrainDeviation)"
          :item="selectedTrainDeviation"
          @confirm="onConfirm"
        />
      </v-dialog>
    </template>

    <v-btn
      @click="exportExcel"
      slot="right"
      rounded
      :disabled="!tableData.length"
      :loading="exporting"
    >
      <v-icon left small>mdi-file-export-outline</v-icon>
      Export Excel</v-btn
    >
  </MasterdataTableContainer>
</template>

<script>
import MasterdataTableContainer from '@/modules/masterdata/components/MasterdataTableContainer'
import { get } from 'vuex-pathify'
import { format, addDays } from 'date-fns'
import trainDeviationTypes from '@/common/trainDeviationTypes'
import LinkDeviationTrainDeviationModal from './LinkDeviationTrainDeviationModal.vue'
import orderBy from 'lodash.orderby'
import { exportExcel } from '@/services/exportExcel.service'

export default {
  name: 'LinkDeviationTrainDeviationTable',

  components: {
    MasterdataTableContainer,
    LinkDeviationTrainDeviationModal
  },

  data() {
    return {
      exporting: false,
      dateDialoag: false,
      dates: [
        format(addDays(new Date(), -1), 'yyyy-MM-dd'),
        format(new Date(), 'yyyy-MM-dd')
      ],
      headers: [
        {
          text: 'Händelse',
          value: '_event'
        },
        {
          text: 'Avvikelse',
          value: '_deviation_type'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Tågnr.',
          value: 'train_number'
        },
        {
          text: 'Teknisktnr.',
          value: 'technical_number'
        },
        {
          text: 'Från',
          value: '_from'
        },
        {
          text: 'Till',
          value: '_to'
        },
        {
          text: 'Avg.',
          value: '_departure'
        },
        {
          text: 'Ank.',
          value: '_arrival'
        }
      ]
    }
  },

  watch: {
    dates: {
      handler: 'onConfirm',
      immediate: true
    }
  },

  computed: {
    stops: get('event/stops'),
    selectedTrainDeviation: get('linkDeviation/selectedTrainDeviation'),
    unhandledTrainDeviations: get('linkDeviation/unhandledTrainDeviations'),

    datesSorted() {
      return orderBy(this.dates, [x => x], ['asc'])
    },

    dateRangeText() {
      return this.dates.join(' ~ ')
    },

    tableData() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }
      return orderBy(
        (this.unhandledTrainDeviations || []).map(x => {
          return {
            ...x,
            _event: x.trainDeviation?.event?.title || '',
            _from: findLocationName(x.from),
            _to: findLocationName(x.to),
            _deviation_type: trainDeviationTypes[x.deviation_type],
            _departure: format(new Date(x.departure), 'yyyy-MM-dd HH:mm'),
            _arrival: format(new Date(x.arrival), 'yyyy-MM-dd HH:mm')
          }
        }),
        ['departure'],
        ['desc']
      )
    }
  },

  methods: {
    onConfirm() {
      if (this.datesSorted.length !== 2) return
      const [from, to] = this.datesSorted
      this.$store.dispatch('linkDeviation/fetchUnhandledTrainDeviations', {
        district_id: this.$store.get('app/selectedDistrictId'),
        from,
        to
      })
    },

    onRowClick(item) {
      this.$store.set('linkDeviation/selectedTrainDeviation', item)
    },

    async exportExcel() {
      this.exporting = true

      const pluckKeys = x => {
        return {
          Händelse: x._event,
          Avvikelse: x._deviation_type,
          Type: x.type,
          'Tågnr.': x.train_number,
          Teknisktnr: x.technical_number,
          Från: x._from,
          Till: x._to,
          Avg: x._departure,
          Ank: x._arrival,
          Orsak: x.delay_reason_description,
          Ansvar: x.responsible,
          Kommentar: x.comment,
          THR: x.thr,
          ÖDOC: x.odoc
        }
      }

      await exportExcel({
        name: `Tågavvikelser ${this.dateRangeText}`,
        sheets: [
          {
            name: 'Tågavvikelser',
            data: this.tableData.map(pluckKeys)
          }
        ]
      })

      this.exporting = false
    }
  }
}
</script>
